export const path = (root: string, sub_link: string, queryParams?: Record<string, string>) =>
  `${root}${sub_link}${queryParams ? `?${new URLSearchParams(queryParams).toString()}` : ""}`;

const AUTH_ROOT = "/auth";
export const DASHBOARD_ROOT = { main: "/dashboard/main", custom: "/dashboard/custom" };

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: path(AUTH_ROOT, "/login"),
  register: path(AUTH_ROOT, "/register"),
};

export const paths = {
  notifications: "/notifications",

  main: {
    root: DASHBOARD_ROOT.main,
    // Social media
    youtube: path(DASHBOARD_ROOT.main, "/youtube"),
    twitter: path(DASHBOARD_ROOT.main, "/twitter"),
    // Newspaper
    TheMercuryNews: path(DASHBOARD_ROOT.main, "/mercurynews"),
    quartz: path(DASHBOARD_ROOT.main, "/quartz"),
    medium: path(DASHBOARD_ROOT.main, "/medium"),
    forbes: path(DASHBOARD_ROOT.main, "/forbes"),
    NYCTimes: path(DASHBOARD_ROOT.main, "/nyctimes"),
  },

  custom: {
    root: DASHBOARD_ROOT.custom,
    youtube: (searchParams?: Record<string, string>) =>
      path(DASHBOARD_ROOT.custom, "/youtube", searchParams),
    twitter: (searchParams?: Record<string, string>) =>
      path(DASHBOARD_ROOT.custom, "/twitter", searchParams),
    mercury_news: (searchParams?: Record<string, string>) =>
      path(DASHBOARD_ROOT.custom, "/mercurynews", searchParams),
    quartz: (searchParams?: Record<string, string>) =>
      path(DASHBOARD_ROOT.custom, "/quartz", searchParams),
    medium: (searchParams?: Record<string, string>) =>
      path(DASHBOARD_ROOT.custom, "/medium", searchParams),
    forbes: (searchParams?: Record<string, string>) =>
      path(DASHBOARD_ROOT.custom, "/forbes", searchParams),
    nyc_times: (searchParams?: Record<string, string>) =>
      path(DASHBOARD_ROOT.custom, "/nyctimes", searchParams),
  },
};

export const PATH_AFTER_LOGIN = paths.main.youtube;
